import React, { useState, useEffect } from 'react';
import { Modal, Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import AssociationRegister from '../auth/AssociationRegister';
import associationApi from '../../api/associationApi';

const EditAssociationProfile = ({ visible, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(true);
  const [associationData, setAssociationData] = useState(null);

  useEffect(() => {
    if (visible) {
      fetchAssociationData();
    }
  }, [visible]);

  const fetchAssociationData = async () => {
    try {
      setLoading(true);
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      
      if (userInfo.association) {
        const data = await associationApi.getAssociationProfile(userInfo.association);
        setAssociationData(data);
      } else {
        message.error('No association ID found. Please login again.');
      }
    } catch (error) {
      message.error('Failed to load association data');
      console.error('Error fetching association data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    message.success('Profile updated successfully!');
    if (onSuccess) onSuccess();
    onClose();
  };

  return (
    <Modal
      title="Edit Association Profile"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1100}
      centered
      destroyOnClose
      bodyStyle={{ 
        maxHeight: '80vh', 
        overflowY: 'auto',
        padding: '24px'
      }}
    >
      {loading ? (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px' 
        }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: '#3C007A' }} spin />} />
        </div>
      ) : (
        <AssociationRegister 
          editingAssociation={associationData} 
          onSuccess={handleSuccess}
        />
      )}
    </Modal>
  );
};

export default EditAssociationProfile;
